const WhyUs = () => {
  const features = [
    {
      icon: '🌐',
      title: 'Worldwide Network',
      description: 'Strong alliances across 160+ countries empower seamless transportation and cross-border operations.',
    },
    {
      icon: '📑',
      title: 'Regulatory Expertise',
      description: 'Deep knowledge of customs laws, international trade rules, and compliance procedures across major global markets.',
    },
    {
      icon: '🖥️',
      title: 'Smart Technology',
      description: 'Advanced digital dashboards, shipment tracking, and automated updates offer real-time visibility throughout your logistics lifecycle.',
    },
  ]

  return (
    <section className="py-20 bg-charcoal-900 border-t border-charcoal-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-white">
            Powering Global Trade with Intelligence & Reliability
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto text-lg">
            For nearly two decades, Unitradeinternational has been a dependable logistics partner for businesses seeking smooth, cost-efficient, and transparent global freight operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="card group hover:-translate-y-2 transition-all duration-300 text-center"
            >
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-white group-hover:text-gray-200">
                {feature.title}
              </h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyUs
